import './UniversityBlock.css';
import React from 'react';
import { get, getMediaHost, injectImageResolution, pathJoin } from "../../utils";
import LazyPicture from "../atoms/LazyPicture/LazyPicture";
import ScrollAnimation from "react-animate-on-scroll";
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as RightArrowSeeMore } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as LeftArrowSeeMore } from '../../resources/icons/IconChevronLeftLight.svg';
import { tealiumClickFunc, tealiumMergeClickData } from "../../utils/tealium";
// https://stackoverflow.com/a/27761572
const numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const UniversityBlock = _ref => {
  let {
    hit,
    rtl,
    analytics = {},
    lang: {
      anualFee,
      visitWebsite,
      universityDescription,
      fieldOfStudy,
      AED
    }
  } = _ref;
  const image = get(hit, 'image');
  const title = get(hit, 'title');
  const established = get(hit, 'established');
  const numberStudents = get(hit, 'numberStudents');
  const graduatesPerYear = get(hit, 'graduatesPerYear');
  const description = get(hit, 'description');
  const website = get(hit, 'website');
  const universityPrograms = get(hit, 'universityPrograms.programs', []);
  const annualFeeRange = universityPrograms.map(_ref2 => {
    let {
      annualFee
    } = _ref2;
    return annualFee;
  });
  const specializations = universityPrograms.map(_ref3 => {
    let {
      specialization
    } = _ref3;
    return specialization;
  });
  const minAnnualFee = Math.min(...annualFeeRange);
  const maxAnualFee = Math.max(...annualFeeRange);
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), image])}`, 340, 243);
  const prefix = `${rtl ? '' : AED + ' '}`;
  const postfix = `${rtl ? ' ' + AED : ''}`;
  const annualFeeValueRange = minAnnualFee === maxAnualFee ? `${prefix}${numberWithCommas(minAnnualFee)}${postfix}` : `${prefix}${numberWithCommas(minAnnualFee)}${postfix} - ${prefix}${numberWithCommas(maxAnualFee)}${postfix}`;
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12  university__item-col university"
  }, /*#__PURE__*/React.createElement("div", {
    className: "university__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "university__image-wrap",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(analytics.bannerClickAnalytics, analytics.params), title);
    }
  }, hit.image && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "university__image",
    src: imgSrc,
    alt: title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "university__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__title",
    onClick: () => tealiumClickFunc(tealiumMergeClickData(analytics.titleClickAnalytics, analytics.params), title)
  }, title), description && description.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__tizer"
  }, description) : universityDescription && /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__tizer"
  }, universityDescription.replace('#universityTitle#', title).replace('#establishedYear#', new Date(established).getFullYear().toString()).replace('#numberStudents#', numberStudents).replace('#graduatesPerYear#', graduatesPerYear).replace('#universityTitle#', title)), specializations.length ? /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__specializations-field-of-study"
  }, /*#__PURE__*/React.createElement("span", {
    className: "specializations-field-of-study-title"
  }, fieldOfStudy), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "specializations-field-of-study-value"
  }, specializations.join(', '))) : null, annualFeeRange.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__anual-fee"
  }, /*#__PURE__*/React.createElement("span", {
    className: "anual-fee-title"
  }, anualFee), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "anual-fee-value-range"
  }, annualFeeValueRange)) : null, website && visitWebsite && /*#__PURE__*/React.createElement("div", {
    className: "see-more"
  }, /*#__PURE__*/React.createElement("a", {
    className: `see-more-link see-more-link-arrow`,
    href: website,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(analytics.visitWebsiteAnalytics, analytics.params), title);
    }
  }, visitWebsite, rtl ? /*#__PURE__*/React.createElement(LeftArrowSeeMore, null) : /*#__PURE__*/React.createElement(RightArrowSeeMore, null))))))));
};
const StyledWrapper = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    minHeight: true,
    className: `${commonStyles}`
  }, children);
};
const commonStyles = "c1t568qk";